import React from 'react'
import { Card } from 'transfix-ui/components/Card'
import { ReactComponent as NoLoadsIllustration } from 'apps/fleet-planner/components/illustrations/NoLoadsIllustration.svg'
import { ReactComponent as CarrierEmptyIllustration } from 'apps/fleet-planner/components/illustrations/onboarding/CarrierEmpty.svg'

export const StartSearch = () => (
  <div className='section-pa3 tc'>
    <div className='mb4'>
      <div className='body-medium mb5'>Start a search to find loads to book.</div>
      <CarrierEmptyIllustration />
    </div>
  </div>
)

export const NoLoadsMatch = () => (
  <Card className='pa0 ma5 mt3'>
    <div className='section-pa3 tc pa6'>
      <div className='mb4'>
        <div className='body-medium mb5'>Sorry, no loads match your search.</div>
        <NoLoadsIllustration />
      </div>
    </div>
  </Card>
)
